const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://newsletter-subscription-api.soma-9d3.workers.dev';

export class ApiService {
  static async subscribe(email) {
    try {
      console.log('API 요청 시작:', `${API_BASE_URL}/api/subscribe`);
      
      const response = await fetch(`${API_BASE_URL}/api/subscribe`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      console.log('응답 상태:', response.status);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log('응답 데이터:', data);
      
      // 성공 메시지에 이모지 추가
      if (data.success && data.message) {
        data.message = `🎉 ${data.message}`;
      }
      
      return data;
    } catch (error) {
      console.error('구독 요청 오류:', error);
      
      if (error.name === 'TypeError' && error.message.includes('fetch')) {
        return {
          success: false,
          error: '서버에 연결할 수 없습니다. 잠시 후 다시 시도해주세요.',
        };
      }
      
      return {
        success: false,
        error: `네트워크 오류: ${error.message}`,
      };
    }
  }

  static async getStats() {
    try {
      const response = await fetch(`${API_BASE_URL}/api/stats`);
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('통계 조회 오류:', error);
      return {
        success: false,
        error: '통계를 불러올 수 없습니다.',
      };
    }
  }

  static async healthCheck() {
    try {
      const response = await fetch(`${API_BASE_URL}/health`);
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('헬스 체크 오류:', error);
      return {
        success: false,
        error: '서버에 연결할 수 없습니다.',
      };
    }
  }
}
